import gallery from "./gallery.png";
import galleryActive from "./gallery-active.png";

import speaker from "./speaker.png";
import speakerActive from "./speaker-active.png";

import thumbnail from "./thumbnail.png";
import thumbnailActive from "./thumbnail-active.png";

import side from "./side.png";
import sideActive from "./side-active.png";

import dual from "./dual.png";
import dualActive from "./dual-active.png";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  gallery,
  galleryActive,
  speaker,
  speakerActive,
  thumbnail,
  thumbnailActive,
  side,
  sideActive,
  dual,
  dualActive,
};
